import { render } from "./ChevronDown.vue?vue&type=template&id=4bbb31d0&lang=pug"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__